@if (!(fieldValidationOptions.length > 1)) {
  <div>
    There are no validations for this type of form element.
  </div>
} @else {
  @if (!currentQuestion.contextTarget) {
    <div>
      Please enter Context Target on the data tab in order to configure validations.
    </div>
  } @else {
    <div class="grid-x">
      <div class="auto cell">
        <label>
          <span class="label-text" (click)="log()">Validation Name:</span>
          <input type="text" [(ngModel)]="currentValidation.name">
        </label>
      </div>
    </div>
    <div class="grid-x">
      <div class="auto cell">
        <label>
          <span class="label-text">Choose Field Validation:</span>
          <!-- TODO: make sure 'key' is the correct property -->
          <select [(ngModel)]="currentValidation.key" (ngModelChange)="generateCannedRule()" [disabled]="isEditingExistingValidation">
            @for (validation of fieldValidationOptions; track validation) {
              <option [ngValue]="validation.id">{{validation.text}}</option>
            }
          </select>
        </label>
      </div>
    </div>
    <div class="grid-x" [style.display]="currentValidation.key !== 'custom' ? 'none' : 'block'">
      <rules-editor [type]="currentValidation.name" [(rule)]="currentValidation"></rules-editor>
    </div>
    <div class="grid-x">
      <div class="auto cell">
        <a class="formalink">
          To build a custom validation, expression click here.
        </a>
      </div>
    </div>
    @if (customValueText) {
      <div class="grid-x">
        <div class="auto cell">
          <label>
            <span class="label-text">{{customValueText}}:</span>
            <input type="text" [(ngModel)]="customValue">
          </label>
        </div>
      </div>
    }
    <div class="grid-x">
      <div class="auto cell">
        <div class="checkbox">
          <label>
            <input class="show-for-sr" type="checkbox" [attr.id]="currentValidation.key" [(ngModel)]="currentValidation.onSubmitOnly" />
            <label aria-hidden="true" [attr.for]="currentValidation.key" class="inline">
              <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
              <span class="control-label-text">Validation required upon flow submit only</span>
            </label>
          </label>
        </div>
      </div>
    </div>
    <div class="grid-x">
      <div class="auto cell">
        <label>
          <span class="label-text">Message to Display if Validation Fails:</span>
          <input type="text" [(ngModel)]="currentValidation.message">
        </label>
      </div>
    </div>
    <div class="form-button-group">
      <button class="button hollow no-margin-bottom" id="fbBtnUpdateValidation" [disabled]="isInvalidValidation()" (click)="updateValidation()"
        [ngClass]="{'hide':!isEditingExistingValidation}">
        Update
      </button>
      <button class="button hollow no-margin-bottom" id="fbBtnAddValidation" [disabled]="isInvalidValidation()" (click)="addValidation()"
        [ngClass]="{'hide':isEditingExistingValidation}">
        Add Validation
      </button>
      @if (isEditingExistingValidation) {
        <button class="button hollow no-margin-bottom" id="fbBtnCancelValidation" (click)="cancelValidation()">
          Cancel
        </button>
      }
    </div>
    <hr />
    <span [ngClass]="{'hide': hideNoValidation()}">No Validation(s) Added</span>
    <ol class="no-list-style">
      @for (validation of currentQuestion.validationRules; track validation) {
        <li [ngClass]="{'active': validation.ruleId === currentValidation.ruleId}">
          <span class="padding-left">{{validation.name}}</span>
          <button (click)="deleteValidation(validation.ruleId)" attr.aria-label="Delete Validation '{{validation.name}}'" title="Delete Validation" class="float-right"><svg-icon icon="icon-trash" class="tiny" attr.aria-hidden="true"></svg-icon></button>
          <button (click)="editValidation(validation)" attr.aria-label="Edit Validation '{{validation.name}}'" title="Edit Validation" class="float-right margin-right"><svg-icon icon="icon-pencil" class="tiny" attr.aria-hidden="true"></svg-icon></button>
        </li>
      }
    </ol>
  }
}
